import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import { SupportUserGate } from "views/SupportConsole/SupportUserGate";

export const SupportRoute = () => {
  const sysAdmin = useSelector(
    (state) => state.userCompanySettings.supportPrivileges?.sysAdmin
  );
  const sosSupport = useSelector(
    (state) => state.userCompanySettings.supportPrivileges?.sosSupport
  );
  const isSupportActivatedCompanyUser = useSelector(
    (state) => state.userCompanySettings.company.supportUser
  );
  if (isSupportActivatedCompanyUser) {
    return <SupportUserGate />;
  }
  if (sysAdmin || sosSupport) {
    return <Outlet />;
  }
  return <Navigate to={"/"} />;
};
